// removed by extract-text-webpack-plugin
module.exports = {"BannerItems":"BannerItems__BannerItems__3rp0Q","Content":"BannerItems__Content__35fTk"};


//////////////////
// WEBPACK FOOTER
// ./client/src/components/Banner/BannerItems.css
// module id = 378
// module chunks = 0